import { createSelector } from '@reduxjs/toolkit';

import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';

export const projectDescriptionsByIriSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      diagramSnapshotSelector(projectId),
      (diagram) => diagram?.model?.modelData?.descriptionsByIri || {}
    )
);
